<span>
  @if (isUnread) {
    <rt-dot color="unread" margin-right-small-x></rt-dot>
  }
  <ng-content></ng-content>
  @if ((count | typeof) === 'string' || $any(count) > 0) {
    <rt-badge margin-left-small-x [color]="countColor" [text]="count"> </rt-badge>
  }
</span>

@if (hrefTarget && href) {
  <a [href]="href" target="{{ hrefTarget }}"></a>
}
@if (!hrefTarget && href) {
  <a [href]="href"></a>
}
